var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenDroplet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9304 37.918C44.9538 40.8096 44.3901 43.6771 43.2716 46.3552C42.1531 49.0333 40.5021 51.4689 38.4137 53.5217C36.3253 55.5745 33.8409 57.2038 31.1037 58.3157C28.3665 59.4276 25.4307 60 22.4655 60C19.5004 60 16.5646 59.4276 13.8274 58.3157C11.0902 57.2038 8.60579 55.5745 6.51741 53.5217C4.42903 51.4689 2.77802 49.0333 1.65955 46.3552C0.541076 43.6771 -0.0227104 40.8096 0.000700267 37.918C0.000700267 25.8177 22.4662 0 22.4662 0C22.4662 0 44.9304 25.8177 44.9304 37.918Z",
    fill: "url(#paint0_linear_1339_400)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1991 51.5164C20.9621 51.5164 15.9397 49.4876 12.2366 45.8763C8.5335 42.2649 6.45313 37.3669 6.45313 32.2597C6.46899 31.3755 6.58214 30.4954 6.79063 29.6348C5.6787 32.1655 4.98829 34.5131 4.98829 36.4388C4.9844 40.2361 6.20383 43.9386 8.47437 47.0235C10.7449 50.1083 13.9518 52.4195 17.6422 53.6308C21.3325 54.8421 25.3198 54.8921 29.0408 53.7739C32.7619 52.6556 36.0287 50.4256 38.3799 47.3988C34.9101 50.0684 30.6187 51.5191 26.1991 51.5164Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_400",
    x1: 0,
    y1: 30.0008,
    x2: 44.936,
    y2: 30.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#25BBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766956,
    stopColor: "#08BD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0ABA8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#07BD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#21CEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2ED7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#42E7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E7C7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDroplet);
export default __webpack_public_path__ + "static/media/greenDroplet.eea78f54ff643c476279f7a70366b641.svg";
export { ForwardRef as ReactComponent };